import { all } from 'redux-saga/effects';

import scheduleSagas from './schedule';

export default function* rootSaga() {
  yield all([scheduleSagas()]);
}
